const benefitsBackground = document.querySelector('.home__benefits__background__image');

/**
 * Set the parallax effect on the benefits background
 */
const setParallax = () => {
  const y = window.innerHeight - benefitsBackground.getBoundingClientRect().top;
  if (y > 0) {
    const offset = 0.15 * y;
    benefitsBackground.style.transform = `translate3d(-50%, -${offset}px, 0)`;
  }
};

/**
 * Adds and removes the scroll event listener based on the visibility of the benefits background
 *
 * @return {void}
 */
const parallaxBackground = () => {
  if (!benefitsBackground) return;

  const observerOptions = {
    root: null, // Use the viewport as the root
    rootMargin: '0px',
    threshold: 0, // Trigger when at element is visible
  };

  /**
   * Callback for the IntersectionObserver
   *
   * @param {IntersectionObserverEntry[]} entries - The entries to observe
   *
   * @return {void}
   */
  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setParallax();
        document.addEventListener('scroll', setParallax);
      } else {
        document.removeEventListener('scroll', setParallax);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  observer.observe(benefitsBackground);
};

/**
 * Initialize the parallax effect on the benefits background
 */
// Handle any reduced motion preferences.
const motionQuery = matchMedia('(prefers-reduced-motion)');
window.addEventListener('load', () => {
  if (!motionQuery.matches) {
    parallaxBackground();
  }
});
